import type { LoginAPI, } from "@/apis/user/types"
import { useCookies, } from "@vueuse/integrations/useCookies"

export const TOKEN_NAME = "jwt_token"
// gorgias
export const GORGIAS_TOKEN = "token"
export const GORGIAS_ORDER = "orderId"
export const GORGIAS_CUSTOMER = "cid"
export const GORGIAS_SHOP = "shop"
export const USER_INFO = "user_info"

const state = useSessionStorage(TOKEN_NAME, "",)
const cookies = useCookies([TOKEN_NAME,],)

const gorgias_token = useLocalStorage(GORGIAS_TOKEN, "",)
const gorgias_order = useLocalStorage(GORGIAS_ORDER, "",)
const gorgias_customer = useLocalStorage(GORGIAS_CUSTOMER, "",)
const gorgias_shop = useLocalStorage(GORGIAS_SHOP, "",)
const userInfo = useLocalStorage(USER_INFO, "",)

export function getToken() {
  return state.value
}

export function getGorgiasToken() {
  return gorgias_token.value
}

export function getGorgiasOrder() {
  return gorgias_order.value
}

export function getGorgiasCustomer() {
  return gorgias_customer.value
}

export function getGorgiasShop() {
  return gorgias_shop.value
}

export function getUserInfo(): LoginAPI.Data | null {
  return JSON.parse(userInfo.value,)
}

export function useToken() {
  return {
    getToken: () => {
      return state.value
    },
    setToken: (token: string,) => {
      state.value = token
      cookies.set(TOKEN_NAME, token,)
    },
    removeToken: () => {
      state.value = null
      cookies.remove(TOKEN_NAME,)
    },
    getGorgiasToken: () => {
      return gorgias_token.value
    },
    getGorgiasOrder: () => {
      return gorgias_order.value
    },
    getGorgiasCustomer: () => {
      return gorgias_customer.value
    },
    getGorgiasShop: () => {
      return gorgias_shop.value
    },
    setGorgiasToken: (token: string,) => {
      gorgias_token.value = token
    },
    setGorgiasOrder: (order: string,) => {
      gorgias_order.value = order
    },
    setGorgiasCustomer: (customer: string,) => {
      gorgias_customer.value = customer
    },
    setGorgiasShop: (shop: string,) => {
      gorgias_shop.value = shop
    },
    removeGorgiasToken: () => {
      gorgias_token.value = null
    },
    removeGorgiasCustomer: () => {
      gorgias_customer.value = null
    },
    removeGorgiasOrder: () => {
      gorgias_order.value = null
    },
    removeGorgiasShop: () => {
      gorgias_shop.value = null
    },
    setUserInfo: (data: LoginAPI.Data,) => {
      userInfo.value = JSON.stringify(data,)
    },
  }
}
